const platforms = Object.freeze({
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
})

export default platforms
